export default __webpack_public_path__ + "static/media/GCodeImg.4c4a72a7.jpg";